import { render, staticRenderFns } from "./HomePac.vue?vue&type=template&id=f4312f8a"
import script from "./HomePac.vue?vue&type=script&lang=js"
export * from "./HomePac.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports